//
var fn_owl_carousel = function () {

  // > Slider-1
  $('.owl-carousel.slider-1').owlCarousel({
    items: 1,
    slideBy: 1,
    loop: false,
    rewind: false,
    nav: true,
    pagination: true,
    navText: ['<span class="sr-only">Précédent</span><span class="icon icon-fleche-prev" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="icon icon-fleche-next" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    // stagePadding: 100,
    margin: 0,
    URLhashListener: true,
    autoplayHoverPause: true,
    startPosition: 'URLHash',
    responsiveClass: true
  })

  // > Slider-hero
  var sliderhero = $('.owl-carousel.slider-hero')
  var content_is_clonable = sliderhero.parents('.o-section-hero__inner').find('.o-section-hero__svg-holder')

  sliderhero
    .on('initialized.owl.carousel', function () {
      if ($(content_is_clonable).length > 0) {
        $(content_is_clonable).clone().appendTo(sliderhero)
        $(content_is_clonable).remove()
      }
    })
    .owlCarousel({
      items: 1,
      slideBy: 1,
      autoplay: true,
      autoplayTimeout: 7000,
      loop: false,
      rewind: true,
      nav: false,
      navText: ['<span class="sr-only">Précédent</span><span class="icon icon-arrow-left" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="icon icon-arrow-right" aria-hidden="true"></span>'],
      navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
      rewindNav: true,
      // stagePadding: 100,
      margin: 0,
      URLhashListener: true,
      // autoplayHoverPause: true,
      startPosition: 'URLHash',
      responsiveClass: true,
      responsive: {
        992: {
          nav: false
        },
        1200: {
          nav: true
        }
      }

    })

  // > Slider-news
  // Get Left of bs4 container so we can move owl news carousel accordingly - offset is only calculated while .rwd-desktop 
  // setTimeout(function () {}, 500);
  var slidernews = $('.owl-carousel.slider-news');
  var slidernews_currentItem = slidernews.currentItem;
  if ($('.o-section-news__wrapper .container').length > 0){
    var slidernews_pad_l = $('.o-section-news__wrapper .container').offset().left;
  }

  slidernews
    .on('initialized.owl.carousel', function (e) {
      // > Setting left position
      slidernews.css('left', slidernews_pad_l)
      slidernews.children().find('.owl-item').removeClass('owl-item-scaled')
      slidernews_currentItem = $('.owl-item', slidernews).eq(e.item.index)
      slidernews_currentItem.addClass('owl-item-scaled')
    })
    .owlCarousel({
      items: 1,
      slideBy: 1,
      autoWidth: true,
      autoHeight: false,
      loop: true,
      rewind: false,
      nav: false,
      dots: true,
      pagination: true,
      // navContainerClass: $('.slider-news-btn__wrapper'),
      navText: ['<span class="sr-only">Précédent</span><span class="icon icon-fleche-prev" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="icon icon-fleche-next" aria-hidden="true"></span>'],
      navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
      // rewindNav: true,
      margin: 0,
      // URLhashListener: true,
      autoplayHoverPause: true,
      // startPosition: 'URLHash',
      responsiveClass: true,
      responsive: {
        768: {
          items: 2,
          slideBy: 1,
          nav: false,
          dots: true
        },
        1200: {
          items: 3,
          slideBy: 1,
          nav: true,
          dots: true
        }
      }
    })
  slidernews
    .on('resized.owl.carousel', function () {
      // > Setting left position
      // Redefining VAr to get updated value here
      if ($('.o-section-news__wrapper .container').length > 0){
        var slidernews_pad_l = $('.o-section-news__wrapper .container').offset().left;
      }
      slidernews.css('left', slidernews_pad_l)
    })
    .on('changed.owl.carousel', function (e) {
      // console.log("current: ",e.relatedTarget.current())
      // console.log("current: ",e.item.index) //same
      // console.log("total: ",e.item.count)   //total
      slidernews.children().find('.owl-item').removeClass('owl-item-scaled')
      slidernews_currentItem = $('.owl-item', slidernews).eq(e.item.index)
      slidernews_currentItem.addClass('owl-item-scaled')
    })
    .on('changed.owl.carousel', function (event) {
      // slidernews.children().find('.owl-item').removeClass('owl-item-scaled')
    })
    .on('translated.owl.carousel', function (event) {
      // slidernews_currentItem = $('.owl-item', slidernews).eq(event.item.index)
      // slidernews_currentItem.addClass('owl-item-scaled')
      // slidernews.children().find('.owl-item').removeClass('owl-item-scaled')
    })


  // > Slider-kfact
  $('.owl-carousel.slider-kfact').owlCarousel({
    items: 1,
    slideBy: 1,
    autoWidth: false,
    autoHeight: true,
    loop: false,
    rewind: true,
    nav: false,
    dots: true,
    pagination: true,
    // navContainerClass: $('.slider-news-btn__wrapper'),
    navText: ['<span class="sr-only">Précédent</span><span class="icon icon-fleche-prev" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="icon icon-fleche-next" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    // URLhashListener: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    // startPosition: 'URLHash',
    responsiveClass: true,
    animateOut: 'fadeOut'
  })

  // > Slider-partners
  $('.owl-carousel.slider-partners').owlCarousel({
    items: 1,
    slideBy: 1,
    autoWidth: false,
    autoHeight: false,
    loop: true,
    rewind: false,
    nav: false,
    dots: false,
    pagination: false,
    navText: ['<span class="sr-only">Précédent</span><span class="icon icon-fleche-prev" aria-hidden="true"></span>', '<span class="sr-only">Suivant</span><span class="icon icon-fleche-next" aria-hidden="true"></span>'],
    navClass: ['btn btn-owl--prev', 'btn btn-owl--next'],
    // rewindNav: true,
    margin: 0,
    // URLhashListener: true,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    // startPosition: 'URLHash',
    responsiveClass: true,
    responsive: {
      768: {
        items: 3,
        slideBy: 1,
        nav: false
      },
      1200: {
        items: 5,
        slideBy: 1,
        nav: false
      }
    }
  })
}
